var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCigarBottleNeck = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M68.03 34.87v7.6c0 .58-.4 1.09-.97 1.23-3.55.84-7.85 1.61-12.78 1.98-1.34 2.8-3.66 4.65-6.28 4.65s-4.94-1.85-6.28-4.65a82.36 82.36 0 0 1-12.78-1.98c-.57-.13-.97-.64-.97-1.23v-7.6c0-.79.72-1.39 1.5-1.23 3.45.69 7.43 1.28 11.86 1.59 1.25-3.3 3.77-5.55 6.67-5.55s5.42 2.25 6.67 5.55c4.44-.31 8.42-.9 11.86-1.59.78-.15 1.5.44 1.5 1.23Z"
  })));
};
export default SvgCigarBottleNeck;